export const useIsServerSideRendered = () => {
    const canUseDOM = !!(
        typeof window !== 'undefined' &&
        window.document &&
        window.document.createElement
    );

    return { isServerSideRendered: !canUseDOM };
};
